// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: 'https://admin.adoratrices.com.ar/api/v1/',
  baseUrl: 'https://admin.adoratrices.com.ar/',
  paymentsUrl: 'http://fenixpayments.staging.keetup.com/',
  recaptchaSiteKey: '6LfXzD8tAAAAAO5LpSJ_NMLXUhwDvVxld1XHas4k',
  apiKeyMap: 'AIzaSyABNf-IQEYMiot3cFI_Ele5uW8ig8DW8FA',
  auth: {
    clientSecret: 'xGbAhWL960HycCoboFNvKdhpWJxnLdxIs55Gjn95',
    clientId: '2'
  },
  adminBaseUrl: 'https://admin.adoratrices.com.ar/password/reset'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
//import 'zone.js/dist/zone-error';  // Included with Angular CLI.
 



